import React, { Component } from 'react';
import { SendDocumentTemplate } from '../../Templates';
import {
  apiGetAllCategories,
  apiPostSendDocument
} from '../../Api/Documents/Documents';
import { isNumber } from '../../Validation';
import Store from '../../Redux/Store';
import formatCategories from '../../Utils/formatCategories';
import combineParentCategoriesWithChild from '../../Utils/combineParentCategoriesWithChild';
import { apiGetMembers } from '../../Api/Profile/Profile';
import { serilizeGetMembers } from '../../Api/Profile/serilizeProfile';
import { connect } from 'react-redux';
import moment from 'moment';
import setFilename from '../../Utils/setFilename';
import DocumentsService from '../../Services/DocumentsService';

class SendDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      category: null,
      type: null,
      description: '',
      files: [],
      contractFamily: Store.getState()?.auth?.user?.contractTypes,
      medicine: {
        benefitaire: '',
        date: null,
        nature: '',
        code: '',
        amount: '',
        files: []
      },
      errorsMedecine: [],
      stepMedicine: 1,
      showNewMutual: false,
      mutual: { amount: '', file: [] },
      remboursement: '48',
      isUploadValid: true,
      isDescriptionValid: true,
      data: [],
      contractTypes: Store.getState().auth.user.contractTypes,
      categoryList: [],
      errorsUpload: [],
      sendDocumentIsLoading: false
    };
  }

  componentDidMount() {
    this.getAllCategories();
    this.getProfile();
  }

  getAllCategories = async () => {
    const res = await DocumentsService.getAllCategories(this.state.contractFamily);
    if (res.error) return;
	if (this.props.history?.location?.state?.goToCategory) {
		this.selectElement(this.props.history?.location?.state?.goToCategory)
	}
	// console.log('history', this.props.history?.location?.state?.goToCategory)
  };

  getCategories = () => {
    if (this.props.categories.length === 0) return [];
    let categories = formatCategories(this.props.categories);
    categories = combineParentCategoriesWithChild(categories);
    if(!this.state.contractFamily.includes('SANTE')){
      categories = categories.filter((el) => { return !((el.name == "Justificatif Enfant") || (el.name == "Portabilité")) })
    }
    return categories.filter((el) => el.canSend !== false);
  };

  getProfile = async () => {
    try {
      const res = await apiGetMembers(this.props.user.memberId);
      const action = {
        type: 'SET_PROFILE',
        value: {
          profile: serilizeGetMembers(res, this.props.user.memberType)
        }
      };
      this.props.dispatch(action);
    } catch (err) {
      this.setState({
        benificiaireList: []
      });
    }
  };

  isMedecineDouce = (type) => {
    return type?.includes('Douce') ?? false;
  };

  onReturn = () => {
    if (this.state.stepMedicine === 2) {
      console.warn('THIS RETURN');
      this.setState({
        stepMedicine: 1
      });
    } else {
      if (this.state.step === 1) {
        console.warn('THIS RETURN 2');
        this.props.history.push('/documents');
      } else {
        console.warn('THIS RETURN 3');
        if(this.state.step == 3){
          const contactParams = new URLSearchParams(document.location.search)
          this.props.history.push({
            pathname: '/documents/send',
            search: `?category=${contactParams.get('category')}`
          })
        } else {
          this.props.history.push('/documents/send');
        }
       
        this.setState({
          step:
            this.state.step === 4 ||
            (this.state.step == 3 && this.state.categoryList.length == 0)
              ? 1
              : this.state.step - 1,
          files: [],
          errorsUpload: [],
          sendDocumentIsLoading: false,
          description: '',
          isUploadValid: true,
          isDescriptionValid: true,
          stepMedicine: 1,
          showNewMutual: false,
          mutual: { amount: '', file: [] },
          remboursement: '48',
          medicine: {
            benefitaire: '',
            date: null,
            nature: '',
            code: '',
            amount: '',
            files: []
          },
          errorsMedecine: []
        });
      }
    }
  };

  selectElement = (value) => {
    var category = value.types;
    if(value.name != "Autres"){
      this.setState({
        step: 2,
        type: value,
        stepMedicine: 1,
        showNewMutual: false,
        mutual: { amount: '', file: [] },
        remboursement: '48',
        categoryList: category
      });
      this.props.history.push({
        pathname: '/documents/send',
        search: `?category=${value.name}`
      })
      if (category.length == 0) {
        this.selectCategory(value);
      }
    } else {
      this.props.history.push("/contact")
    }
    
  };

  selectCategory = (value) => {
    const contactParams = new URLSearchParams(document.location.search)
    this.props.history.push({
      pathname: '/documents/send',
      search: `?category=${contactParams.get('category')}&subCategory=${value.name}`
    })
    this.setState({
      step: 3,
      category: value,
      stepMedicine: 1,
      showNewMutual: false,
      mutual: { amount: '', file: [] },
      remboursement: '48'
    });
  };

  selectFile = (e) => {
    this.setState({ files: e }, () => {
      if (this.state.files.length !== 0) {
        this.validateFileUpload();
      }
    });
  };

  onChange = (e) => {
    this.setState(
      (prev) => ({
        description: e.target.value,
        ...(!prev.isDescriptionValid && prev.description.length === 0
          ? { isDescriptionValid: true }
          : {})
      })
      // this.validateDescription
    );
  };

  validateFileUpload = () => {
    if (!this.state.files.length) {
      this.setState({
        isUploadValid: false
      });
    } else {
      this.setState({
        isUploadValid: true
      });
    }
  };
  validateDescription = () => {
    // if (this.state.description.length < 1) {
    //   this.setState({
    //     isDescriptionValid: false
    //   });
    // } else {
    //   this.setState({
    //     isDescriptionValid: true
    //   });
    // }
    this.setState({
      isDescriptionValid: true
    });
  };

  validateMedecineDouce = (step) => {
    if (step === 1) {
      const { benefitaire, date, nature, code, amount } = this.state.medicine;
      const { files } = this.state;
      let errors = [];

      !benefitaire && errors.push('beneficiaire');
      !date && errors.push('date');
      !nature && errors.push('nature');
      !code && errors.push('code');
      !amount && errors.push('amount');
      files?.length === 0 && errors.push('files');

      if (this.state.showNewMutual) {
        !this.state.mutual.amount && errors.push('amount_other');
        this.state.mutual.file?.length === 0 && errors.push('files_other');
      }
      console.log('ERRORS', errors);

      this.setState({
        errorsMedecine: errors
      });

      if (errors.length === 0) {
        return true;
      }
      return false;
    }
    return true;
  };

  validate = () => {
    if (!this.isMedecineDouce(this.state.category?.name)) {
      this.validateFileUpload();
      this.validateDescription();
      return this.state.files.length;
    }
    return true;
  };

  onSubmit = async () => {
    console.log('onSubmit', this.state.medicine);
    if (this.validate()) {
      this.setState({ errorsUpload: [] });
      const res = await this.sendDocument();
      if (res.status === 200) {
        this.setState({
          step: 4,
          files: [],
          errorsUpload: [],
          sendDocumentIsLoading: false,
          description: '',
          isUploadValid: true,
          isDescriptionValid: true,
          showNewMutual: false,
          mutual: { amount: '', file: [] },
          remboursement: '48',
          medicine: {
            benefitaire: '',
            date: null,
            nature: '',
            code: '',
            amount: '',
            files: []
          },
          errorsMedecine: []
        });
        const contactParams = new URLSearchParams(document.location.search)
          this.props.history.push({
            pathname: '/documents/send',
            search: `?category=${contactParams.get('category')}&subCategory=${contactParams.get('subCategory')}&result=success`
          })
      } else {
        this.setState({
          errorsUpload: res.errors || ["Une erreur s'est produite"]
        });
      }
    }
  };

  sendDocument = async () => {
    this.setState({ sendDocumentIsLoading: true });
    const appendFileTo = (dataToBeCompleted, filesFrom) => {
      for (let i = 0; i < filesFrom.length; i++) {
        console.log(filesFrom[i]);
        dataToBeCompleted.append('Files', filesFrom[i]);
      }
    };

    const data = new FormData();
    data.append('Category.Name', this.state.type.name);
    data.append('Category.Id', this.state.category?.id || this.state.type.id);
    data.append('Category.Type', this.state.category.name);

    if (this.isMedecineDouce(this.state.category.name)) {
      const getDescription = () => {
        const { medicine, mutual, description, showNewMutual } = this.state;
        let desc = '';
        if (description) desc += `${description}\n\n`;
        desc += `Bénéficiaire du soin: ${medicine.benefitaire}`;
        desc += `\nDate du soin: ${moment(medicine.date).format('DD/MM/YYYY')}`;
        desc += `\nNature du soin: ${medicine.nature}`;
        desc += `\nCode Adeli ou N° Siret: ${medicine.code}`;
        desc += `\nMontant dépensé: ${medicine.amount}€`;
        if (showNewMutual)
          desc += `\nMontant remboursé par l'autre mutuelle: ${mutual.amount}€`;
        return desc;
      };

      data.append('Description', getDescription());

      appendFileTo(data, this.state.files);
      if (!this.state.disabledMutual) {
        appendFileTo(data, this.state.mutual.file);
      }
    } else {
      data.append('Description', this.state.description);
      appendFileTo(data, this.state.files);
    }

    // for (let i = 0; i < this.state.files.length; i++) {
    //   data.append('Files', this.state.files[i]);
    // }

    for (var pair of data.entries()) {
      console.log(pair[0] + ', ' + pair[1]);
    }
    const res = await apiPostSendDocument(data);
    this.setState({ sendDocumentIsLoading: false });

    return res;
  };

  senDocument = async () => {
    const appendFileTo = (dataToBeCompleted, filesFrom) => {
      for (let i = 0; i < filesFrom?.length; i++) {
        const fileURI = filesFrom[i].uri;
        const mimeType = mime.getType(fileURI) || 'image/jpg';
        const filenameExtension = mime.getExtension(mimeType);
        const filename = `${setFilename(
          this.state.data.name,
          this.state.subType?.name
        )}${i}.${filenameExtension}`;

        const file = {
          uri: fileURI,
          type: mimeType,
          name: filename
        };
        dataToBeCompleted.append('Files', file, filename);
      }
    };

    let data = new FormData();

    data.append('Category.Name', this.state.data.name);
    data.append('Category.Id', this.state.subType?.id || this.state.data.id);
    data.append('Category.Type', this.state.subType?.name);
    if (this.isMedecineDouce(this.props.route.params?.subType?.name)) {
      const getDescription = () => {
        const { medicine, mutual, description, disabledMutual } = this.state;
        let desc = '';
        if (description) desc += `${description}\n\n`;
        desc += `Bénéficiaire du soin: ${medicine.benefitaire?.[0]?.value}`;
        desc += `\nDate du soin: ${moment(medicine.date, 'YYYY-MM-DD').format(
          'DD/MM/YYYY'
        )}`;
        desc += `\nNature du soin: ${medicine.nature.value}`;
        desc += `\nCode Adeli ou N° Siret: ${medicine.code}`;
        desc += `\nMontant dépensé: ${medicine.amount}€`;
        if (!disabledMutual)
          desc += `\nMontant remboursé par l'autre mutuelle: ${mutual.amount}€`;
        return desc;
      };

      data.append('Description', getDescription());

      appendFileTo(data, this.state.medicine.files);
      if (!this.state.disabledMutual) {
        appendFileTo(data, this.state.mutual.files);
      }
    } else {
      data.append('Description', this.state.description);
      appendFileTo(data, this.state.files);
    }
    const res = await apiPostSendDocument(data);
    return res;
  };

  onChangeMedicine = (value, key) => {
    const aux = { ...this.state.medicine };
    if (key == 'date') {
      aux[key] = value[0];
    } else if (key == 'code' || key == 'amount') {
      if (isNumber(value) || value == '') {
        aux[key] = value;
      }
    } else {
      aux[key] = value;
    }
    this.setState({ medicine: aux });
  };

  medicineStep = (step) => {
    if (this.state.stepMedicine === 1 && step === 2) {
      if (!this.validateMedecineDouce(1)) return false;
    }
    this.setState({
      stepMedicine: step
    });
  };

  openNewMutual = () => {
    this.setState({
      showNewMutual: true
    });
  };

  closeNewMutual = () => {
    this.setState({
      showNewMutual: false,
      mutual: { amount: '', file: [] }
    });
  };

  onChangeMutual = (value, key) => {
    const aux = { ...this.state.mutual };
    aux[key] = value;
    this.setState({ mutual: aux });
  };

  render() {
    return (
      <SendDocumentTemplate
        state={this.state}
        categories={this.getCategories()}
        onReturn={this.onReturn}
        selectElement={this.selectElement}
        selectCategory={this.selectCategory}
        selectFile={this.selectFile}
        onChange={this.onChange}
        onSubmit={this.onSubmit}
        onChangeMedicine={this.onChangeMedicine}
        medicineStep={this.medicineStep}
        errorsMedecine={this.state.errorsMedecine}
        openNewMutual={this.openNewMutual}
        closeNewMutual={this.closeNewMutual}
        onChangeMutual={this.onChangeMutual}
        errorsUpload={this.state.errorsUpload}
        beneficiaries={this.props.beneficiaries}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    beneficiaries: state.profile.profile.map(({ value }) => ({
      value: `${value.name} ${value.lastName}`,
      text: `${value.name} ${value.lastName}`
    })),
    categories: state.DocumentsReducer.categories
  };
};

export default connect(mapStateToProps)(SendDocument);
